import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import ModalUI from '../../../widgets/layout/ModalUI'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import TestAccountListSF from '../../../components/superUser/developer/TestAccountListSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const TestAccountListPageUI = ({context, errorList, accountList, onRefreshClick, selectedAccountId,
    onRecreateClick, recreateSubmitted, onDeleteClick, deleteSubmitted, result, onHideResult,
    createLoanMode, onCreateLoanClick, onCancelCreateLoan
  }) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_t_acc' topnav='settings'
    headerText='Developer' centered={!accountList && (!errorList || errorList.length === 0)}
    page='developer'
  >
    {
      !accountList && (!errorList || errorList.length === 0) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountList &&
      <div>
        <TabLinkUI label='Test Data' to='/su/testdata' active={true} />
        <TabLinkUI label='DB Configurations' to='/su/config' />
        <div className='g_m_top_100' />

        <TestAccountListSF context={context} accountList={accountList}
          onRefreshClick={onRefreshClick} selectedAccountId={selectedAccountId}
          onDeleteClick={onDeleteClick} deleteSubmitted={deleteSubmitted}
          onRecreateClick={onRecreateClick} recreateSubmitted={recreateSubmitted}
          createLoanMode={createLoanMode} onCreateLoanClick={onCreateLoanClick}
          onCancelCreateLoan={onCancelCreateLoan}
        />
      </div>
    }

    <ModalUI
      isOpen={result !== null}
      // event handlers
      onRequestClose={onHideResult}
    >
      <div>Deleted: { result && result.deleted && JSON.stringify(result.deleted) }</div>
      <div>Created: { result && result.created && JSON.stringify(result.created) }</div>
    </ModalUI>
  </SuperUserSettingsPageUI>

export default TestAccountListPageUI
